export function flowStepTitle(step) {
  const lines = (step.step_prompts || []).filter(line => String(line).trim());
  return String((step.step_type === 'message' ? lines[0] : lines.at(-1)) || (step.step_type === 'message' ? 'Untitled message' : 'Untitled question'));
}

export function flowOverviewSummary(step, model) {
  const index = model.indexOf(step);
  const options = step.step_options || [];
  const facts = [];
  if (step.step_config?.group_with_previous) facts.push('Shown with previous question');
  if (step.step_config?.optional) facts.push('Optional');
  if (step.step_config?.skip_if_prefilled) facts.push('Skipped if already answered');
  if (step.step_config?.terminal) facts.push('Ends here without sending answers');
  else {
    const different = options.filter(option => option.goto && String(option.goto) !== String(model[index + 1]?.id));
    if (different.length) facts.push(`${different.length} ${different.length === 1 ? 'choice goes' : 'choices go'} to another question`);
    else if (index < model.length - 1) facts.push(`Continues to ${model[index + 1].step_type === 'message' ? 'message' : 'question'} ${index + 2}`);
    else facts.push('Then finishes and sends answers');
  }
  if (options.some(option => option.config && Object.keys(option.config).length)) facts.push('Custom choice behavior');
  return facts.join(' · ');
}

// Authoring hints, not a substitute for full publish/server validation.
export function flowStepHints(step, model) {
  const hints = [];
  if (!(step.step_prompts || []).some(line => String(line).trim())) hints.push('Add wording');
  if (['text', 'email', 'phone', 'scheduler'].includes(step.step_type) && !step.step_columns?.length) hints.push('Choose an answer field');
  if (['single_select', 'multi_select'].includes(step.step_type)) {
    if (!step.step_options?.length || step.step_options.some(option => !String(option.label || '').trim())) hints.push('Finish the choices');
    if (step.step_options?.some(option => option.goto && (!model.some(target => target.id === option.goto) || option.goto === step.id))) hints.push('Check choice destinations');
  }
  if (step.step_config?.terminal && !!step.step_config.cta?.label?.trim() !== !!step.step_config.cta?.url?.trim()) hints.push('Complete the ending link');
  return hints;
}

export function matchesFlowSearch(step, query) {
  const text = [flowStepTitle(step), ...(step.step_prompts || []), ...(step.step_columns || []), step.step_answer?.label || '', ...(step.step_options || []).map(option => option.label)].join(' ').toLowerCase();
  return text.includes(query.trim().toLowerCase());
}
